import React, { Component } from 'react';
import ContentEditable from 'react-contenteditable';
import styles from './styles.scss';
import classnames from 'classnames';
import { Popover, Menu } from 'material-ui';

export default class InlineInput extends Component {
  constructor(props) {
    super(props);
    this.state = { editedValue: props.value || '', focused: false };
    this.contentEditable = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.contentEditable && this.contentEditable.current) {
        if (this.props.autoFocus) {
          setTimeout(() => {
            this.contentEditable.current.focus();
          });
        }
        this.contentEditable.current.onfocus = () => {
          this.setState({ focused: true });
          if (this.props.onFocus) {
            this.props.onFocus();
          }
        };
        if (!this.props.disabled) {
          this.contentEditable.current.classList.add('inlineInput');
        }
      }
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.props.value) {
      this.setState({ editedValue: newProps.value });
    }
  }

  onChange = e => {
    let { value } = e.target;
    value = value.replace(/<[^>]+>/g, '');

    const txt = document.createElement('textarea');
    txt.innerHTML = value;

    let editedValue = txt.value;

    if (this.props.maxLength) {
      if (editedValue.length > this.props.maxLength) {
        return this.setState({ editedValue: this.state.editedValue });
      }
    }

    this.setState({ editedValue });
  };

  handleReturn = e => {
    switch (e.keyCode) {
      case 8:
        setTimeout(() => {
          if (!this.contentEditable.current.textContent) {
            this.setState({ editedValue: '' });
          }
        });
        break;
      case 13:
        e.target.blur();
        break;
      default:
    }
  };

  onBlur = e => {
    // waiting for autcomplete click to set state
    setTimeout(
      () => {
        const value = this.state.editedValue;
        if (value.trim().length) {
          this.props.onBlur(this.state.editedValue);
        } else {
          if (this.props.allowEmpty) {
            this.props.onBlur('');
          } else {
            this.setState({ editedValue: this.props.value });
            this.props.onBlur(this.props.value);
          }
        }
        this.setState({ focused: false });
      },
      this.props.autoCompleteOptions ? 200 : 0
    );
  };

  autoCompleteOptions = () => {
    const { autoCompleteOptions } = this.props;
    if (autoCompleteOptions) {
      return autoCompleteOptions.filter(val => {
        return val
          .toLowerCase()
          .trim()
          .startsWith(this.state.editedValue.toLowerCase().trim());
      });
    } else {
      return [];
    }
  };

  setAutoCompleteOption = option => {
    this.setState({ editedValue: option });
  };

  focusInline = () => {
    this.contentEditable.current.focus();
  };

  render() {
    const autoCompleteOptions = this.autoCompleteOptions();

    const { placeholder, emptyState } = this.props;

    let value = this.state.editedValue;
    let placeholderOn = false;
    if (placeholder && !this.state.focused && !this.state.editedValue.trim()) {
      placeholderOn = true;
      value = placeholder;
    }

    const isEmptyState =
      emptyState && !this.state.editedValue.trim() && !this.state.focused;

    return (
      <React.Fragment>
        <div
          onClick={this.props.onClick}
          ref={ref => (this.wrapper = ref)}
          className={classnames(styles.wrapper, {
            [styles.alwaysUnderline]: this.props.alwaysUnderline,
            [styles.disabled]: this.props.disabled,
            [styles.fullWidth]: this.props.fullWidth,
            [styles.placeholderOn]: placeholderOn,
            [styles.emptyState]: isEmptyState
          })}>
          <ContentEditable
            innerRef={this.contentEditable}
            html={value} // innerHTML of the editable div
            disabled={this.props.disabled} // use true to disable editing
            onChange={this.onChange} // handle innerHTML change
            onKeyDown={this.handleReturn}
            onBlur={this.onBlur}
            spellCheck={false}
          />
          <Popover
            open={this.state.focused && autoCompleteOptions.length > 0}
            anchorEl={this.wrapper}
            useLayerForClickAway={false}
            className={styles.popover}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}>
            <Menu className={styles.autoComplete}>
              {autoCompleteOptions.map(option => {
                return (
                  <div
                    className={styles.autoCompleteItem}
                    key={option}
                    onClick={() => this.setAutoCompleteOption(option)}>
                    {option}
                  </div>
                );
              })}
            </Menu>
          </Popover>
        </div>
        {isEmptyState && (
          <div className={styles.emptyState} onClick={this.focusInline}>
            {emptyState}
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/util/strictInlineInput/index.js